

export default {
    state: () => ({
        douyinInfo: {
            douyinNo: 'dy6xfhoyynlwn'
        }
    })
}